import { MenuItem } from "@chakra-ui/react";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useTranslation } from "react-i18next";
import { Restricted } from "shared/components/access/Restricted";
import { DropdownButton } from "shared/components/button/DropdownButton";
import { useUrlParamSync } from "shared/hooks/useUrlParamSync";

export const ViewEditDropdownButton = ({
  isEditing,
  setIsEditing,
}: {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <Restricted permission={PermissionTypeEnum.write}>
      <DropdownButton
        title={isEditing ? t("common:edit") : t("common:view")}
        colorScheme="tertiary"
        size="xs"
      >
        <MenuItem onClick={() => setIsEditing(true)}>
          {t("common:edit")}
        </MenuItem>
        <MenuItem onClick={() => setIsEditing(false)}>
          {t("common:view")}
        </MenuItem>
      </DropdownButton>
    </Restricted>
  );
};

export const useViewEditDropdown = () => {
  const [isEditEnabled, setEditEnabled] = useUrlParamSync({
    paramName: "isEditEnabled",
    defaultVal: "false",
  });

  return {
    editModeEnabled: isEditEnabled === "true",
    setEditModeDisabled: () => setEditEnabled("false"),
    setEditMode: (flag: boolean) => {
      setEditEnabled(flag ? "true" : "false");
    },
  };
};
